"use strict";
var Configuration = (function () {
    function Configuration() {
        this.defaultRoute = null;
    }
    return Configuration;
}());
exports.Configuration = Configuration;



//////////////////
// WEBPACK FOOTER
// /Users/nikos/WebstormProjects/warp-router/src/Configuration.ts
// module id = 1
// module chunks = 0